// 효과 텍스처 목록과 로더(vfx-library v1에서 이식). 모든 텍스처는 Tripo Studio GPT Image 2.5로 만든 검은 배경 1024px 원화를 WebP로 줄인 것이다.
// 파일: public/assets/vfx/<id>.webp (origin/codex/vfx-library-v1 vfx-library/public/textures 와 바이트 동일)
import * as THREE from 'three/webgpu';
import { resolveAssetUrl } from '../../pwa/assetMap';

export const TEX_IDS = [
  'slash-crescent', 'shockwave-ring', 'impact-flare', 'dust-puff', 'rune-circle-crimson', 'rune-circle-arcane',
  'lightning-bolt-gold', 'wind-streak-teal', 'shadow-x-slash', 'speed-lines', 'levelup-pillar', 'meteor-blue', 'crimson-splatter',
  // 스킬 트리(2026-10-20, Codex image_gen 원화 → tools/vfx/convert-texture.py). 위쪽(+v)이 진행 방향이 되게 돌려 두었다
  'crescent-wave', 'petal-burst', 'lightning-blade', 'ground-fissure', 'vortex-swirl', 'rune-ring-gold',
] as const;
export type TexId = (typeof TEX_IDS)[number];

export class TextureBank {
  private readonly map = new Map<TexId, THREE.Texture>();
  /** 1x1 검정. 텍스처를 읽기 전 묶음 머티리얼의 초기값(가산: 안 보임, 알파: 투명) */
  readonly blank: THREE.DataTexture;

  constructor() {
    this.blank = new THREE.DataTexture(new Uint8Array([0, 0, 0, 255]), 1, 1);
    this.blank.needsUpdate = true;
  }

  /** ids만 읽는다. 하나라도 실패하면 reject(호출하는 쪽이 잡는다). */
  async load(baseUrl: string, ids: readonly TexId[]): Promise<void> {
    const loader = new THREE.TextureLoader();
    await Promise.all(ids.map(async (id) => {
      const t = await loader.loadAsync(resolveAssetUrl(baseUrl + id + '.webp'));
      t.colorSpace = THREE.SRGBColorSpace;
      t.anisotropy = 4;
      this.map.set(id, t);
    }));
  }

  get(id: TexId): THREE.Texture | null {
    return this.map.get(id) ?? null;
  }

  dispose(): void {
    for (const t of this.map.values()) t.dispose();
    this.map.clear();
    this.blank.dispose();
  }
}

